module.exports = __webpack_public_path__ + "img/notice.507b624c.png";